import { Component, OnInit } from "@angular/core";
import { AjaxService } from "src/app/service/ajax.service";
import { UtilService } from "src/app/service/util.service";
import { API } from "src/environments/environment";

interface LeadTabela {
  idLead: number;
  nome: string;
  telefone: string;
  nomeCrianca: string;
  idade: number | null;
  data: string;
}

@Component({
  selector: "app-quer-participar",
  templateUrl: "./quer-participar.component.html",
  styleUrls: ["./quer-participar.component.scss"],
})
export class QuerParticiparComponent implements OnInit {
  leads: LeadTabela[] = [];
  filteredLeads: LeadTabela[] = [];
  searchText = "";

  constructor(private ajax: AjaxService, public util: UtilService) {}

  ngOnInit(): void {
    this.buscarLeads();
  }

  buscarLeads(): void {
    this.util.showLoading();
    const url = API + "Lead/Lead";
    this.ajax.get(url).subscribe(
      (response) => {
        const lista = response?.data || [];
        const leadsOrdenados = lista
          .map((item: any) => this.mapLead(item))
          .sort((a: LeadTabela, b: LeadTabela) => {
            const dataA = a.data ? new Date(a.data).getTime() : 0;
            const dataB = b.data ? new Date(b.data).getTime() : 0;
            return dataB - dataA;
          });

        const mapaUnicos = new Map<string, LeadTabela>();
        leadsOrdenados.forEach((lead: LeadTabela) => {
          const telefoneNormalizado = this.normalizarTelefone(lead.telefone);
          const nomeNormalizado = (lead.nome || "").toLowerCase().trim();
          const chave =
            [
              telefoneNormalizado || nomeNormalizado,
              this.getDataSomenteDia(lead.data),
            ].join("|");

          if (!mapaUnicos.has(chave)) {
            mapaUnicos.set(chave, lead);
          }
        });

        this.leads = Array.from(mapaUnicos.values());
        this.filteredLeads = [...this.leads];
        this.util.closeLoading();
      },
      () => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao carregar interessados");
      }
    );
  }

  onSearch(): void {
    const termo = (this.searchText || "").toLowerCase().trim();
    if (!termo) {
      this.filteredLeads = [...this.leads];
      return;
    }

    this.filteredLeads = this.leads.filter((lead) =>
      [lead.nome, lead.telefone, lead.nomeCrianca, lead.idade?.toString()]
        .filter(Boolean)
        .some((campo) => (campo as string).toLowerCase().includes(termo))
    );
  }

  private mapLead(item: any): LeadTabela {
    return {
      idLead: item?.iD_LEAD ?? item?.ID_LEAD ?? 0,
      nome: item?.nome ?? item?.NOME ?? "-",
      telefone: item?.telefone ?? item?.TELEFONE ?? "-",
      nomeCrianca: item?.nomE_CRIANCA ?? item?.NOME_CRIANCA ?? "-",
      idade: item?.idade ?? item?.IDADE ?? null,
      data: item?.data ?? item?.DATA ?? null,
    };
  }

  private getDataSomenteDia(data: string): string {
    if (!data) {
      return "";
    }
    const dataObj = new Date(data);
    if (isNaN(dataObj.getTime())) {
      return "";
    }
    return `${dataObj.getFullYear()}-${dataObj.getMonth() + 1}-${dataObj.getDate()}`;
  }

  private normalizarTelefone(telefone: string): string {
    if (!telefone) {
      return "";
    }
    return telefone.replace(/\D/g, "");
  }
}
